import React from 'react';
import { FiX, FiShoppingCart } from 'react-icons/fi';

export default function OrderItemsModal({ isOpen, onClose, items }) {
  if (!isOpen || !items) return null;

  return (
    <div className="admin-modal-overlay-bg" onClick={onClose}>
      <div className="admin-modal-form-card item-viewer animate-scale-up" onClick={(e) => e.stopPropagation()}>
        <header className="modal-form-header">
          <h2><FiShoppingCart className="modal-header-icon" /> Purchased Items Details</h2>
          <button className="modal-close-x-btn" onClick={onClose} aria-label="Close modal"><FiX /></button>
        </header>

        <div className="order-items-grid">
          {items.map((item, idx) => (
            <div key={idx} className="item-detail-row">
              <img src={item.image || "/products/Super Novel.png"} alt={item.title} className="order-item-img-preview" />
              <div className="item-metadata">
                <h4>{item.title}</h4>
                <p>SKU: <code>{item.sku}</code></p>
                <div className="item-calc">
                  <strong>₹{parseFloat(item.price).toFixed(2)}</strong> x {item.quantity} units
                </div>
              </div>
              <div className="item-total-col">
                ₹{(parseFloat(item.price) * item.quantity).toFixed(2)}
              </div>
            </div>
          ))}
          {items.length === 0 && <p className="empty-text">No details logged for order items.</p>}
        </div>

        <footer className="form-action-footer">
          <button className="btn-primary-submit" onClick={onClose}>Close Viewer</button>
        </footer>
      </div>
    </div>
  );
}
